// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"542":"2d467649","998":"aa17bbcf"}[chunkId] + ".chunk.js";
};